import { IAppState } from '../../redux';
import { EMultiPostingAvailablePlatforms } from '../../redux/types/multiPosting/types';
import { selectMultipostingABGroup } from './selectMultipostingABGroup';

export const selectMultiPostingAvailablePlatforms = (state: IAppState) => {
  const multipostingABGroup = selectMultipostingABGroup(state);

  if (!multipostingABGroup) {
    return EMultiPostingAvailablePlatforms.None;
  }

  switch (multipostingABGroup) {
    case 'B':
      return EMultiPostingAvailablePlatforms.All;

    case 'C':
      return EMultiPostingAvailablePlatforms.Free;

    default:
      return EMultiPostingAvailablePlatforms.None;
  }
};
